import { Injectable, Injector } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from '../base-crud.service';
import { TenantModel } from '../../models/tenant/tenant-model';

export interface MetaCredenciaisDto {
  TenantId: string;
  Code: string;
  WabaId: string;
  PhoneNumberId: string;
  RegistradoWpp?: boolean;
  InscritoWebhook?: boolean;
}

export interface MetaRegistroTelefoneDto {
  TenantId: string;
  Pin: string;
}

export interface MetaSubscribedAppsDto {
  data: MetaSubscribedAppItemDto[];
}

export interface MetaSubscribedAppItemDto {
  id: string;
  name: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class TenantService extends BaseCrudService<TenantModel> {  
  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'Tenant';
  }  

  getCurrentTenant(): Observable<TenantModel> {
    return this
      .httpClient
      .get<TenantModel>(`${this.getApiUrl()}${this.getController()}/GetCurrentTenant`, this.getHeaderJson())
      .pipe(
        map(this.extractData)
      );
  }

  getAll(): Observable<TenantModel[]> {
    return this
      .httpClient
      .get<TenantModel>(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  createStartup(model: TenantModel): Observable<any> {
    return this
    .httpClient
    .post(`${this.getApiUrl()}${this.getController()}/CreateStartup`, JSON.stringify(model), this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  saveMetaCredenciais(dto: MetaCredenciaisDto): Observable<boolean> {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/SaveMetaCredenciais`, JSON.stringify(dto), this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  registerMetaPhoneNumber(dto: MetaRegistroTelefoneDto): Observable<boolean> {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/RegisterMetaPhoneNumber`, JSON.stringify(dto), this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  deregisterMetaPhoneNumber(tenantId: string): Observable<boolean> {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/DeregisterPhoneNumber/${tenantId}`, null, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  subscribeMetaApp(tenantId: string): Observable<boolean> {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/SubscribeMetaApp/${tenantId}`, null, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getMetaSubscribedApps(tenantId: string): Observable<MetaSubscribedAppsDto> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetMetaSubscribedApps/${tenantId}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  deleteSubscribedApp(tenantId: string): Observable<boolean> {
    return this
      .httpClient
      .delete(`${this.getApiUrl()}${this.getController()}/DeleteSubscribedApp/${tenantId}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
